export default "__VITE_ASSET__7bfe491a__"